import { initializeEnv } from '@vueron/kiska';
import '@vueron/kiska/style.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';

import './i18n';
import './style/base.css';
import { actionHistory } from './util/actionHistory';
import { initSentry } from './util/sentry';

initializeEnv(import.meta.env);

console.log(String.raw`  ____     _     ____   ____    ___   ____    ___
 / ___|   / \   |  _ \ |  _ \  / _ \ |  _ \  / _ \
 \___ \  / _ \  | |_) || |_) || | | || |_) || | | |
  ___) |/ ___ \ |  __/ |  __/ | |_| ||  _ < | |_| |
 |____//_/   \_\|_|    |_|     \___/ |_| \_\ \___/
`);

dayjs.extend(utc);

async function enableMocking() {
  const { startMocking } = await import('./mock/browser');
  return startMocking();
}

if (import.meta.env.DEV && import.meta.env.VITE_APP_MSW_ENABLED == 1) {
  enableMocking();
}

if (!import.meta.env.DEV) {
  actionHistory.start();
}

initSentry();

const { default: App } = await import('./App');

createRoot(document.getElementById('app')!).render(<App />);
